export type EntryContext =
  | { kind: 'key'; key: string }
  | { kind: 'kakao'; paymentId: number }
  | { kind: 'naverFail'; resultMessage: string }
  | { kind: 'tossFail'; message: string }
  | { kind: 'unknown' }

/**
 * 결과 화면 진입 쿼리 → 분기 결정.
 *  - `?key=` (토스/네이버 success) → key
 *  - `?resultCode=`≠Success (네이버 실패) → naverFail (paymentId 동반돼도 카카오로 오인 방지 — 먼저 검사)
 *  - `?code=&message=` (토스 fail) → tossFail
 *  - `?paymentId=` (카카오 success, S2S 확정) → kakao
 *  - 그 외 → unknown
 */
export function parseEntryContext(searchParams: URLSearchParams): EntryContext {
  const key = searchParams.get('key')
  if (key) return { kind: 'key', key }

  const resultCode = searchParams.get('resultCode')
  if (resultCode && resultCode !== 'Success') {
    return { kind: 'naverFail', resultMessage: searchParams.get('resultMessage') ?? '' }
  }

  const tossCode = searchParams.get('code')
  const tossMessage = searchParams.get('message')
  if (tossCode && tossMessage) return { kind: 'tossFail', message: tossMessage }

  const paymentIdStr = searchParams.get('paymentId')
  if (paymentIdStr) {
    const paymentId = Number(paymentIdStr)
    if (!Number.isNaN(paymentId)) return { kind: 'kakao', paymentId }
  }

  return { kind: 'unknown' }
}
